import React from 'react';
import { useTranslation } from 'react-i18next';
import layoutStyles from '../../styles/layout.module.css';
import styles from './OurWork.module.css';

const OurWork: React.FC = () => {
  const { t } = useTranslation();

  const projects = [
    {
      id: 'musicalArea',
      title: t('ourWork.projects.musicalArea.title'),
      description: t('ourWork.projects.musicalArea.description'),
      location: t('ourWork.projects.musicalArea.location'),
      images: [
        '/melody-creator-app.svg',
        '/rhythm-creator-app.svg',
        '/song-creator-app.svg'
      ],
      highlights: t('ourWork.projects.musicalArea.highlights', { returnObjects: true }) as string[]
    },
    {
      id: 'realEstate',
      title: t('ourWork.projects.realEstate.title'),
      description: t('ourWork.projects.realEstate.description'),
      location: t('ourWork.projects.realEstate.location'),
      images: ['/002-logo-lonja-letra-oscura-Recuperado-copia-1.png'],
      highlights: t('ourWork.projects.realEstate.highlights', { returnObjects: true }) as string[]
    },
    {
      id: 'mentalHealth',
      title: t('ourWork.projects.mentalHealth.title'),
      description: t('ourWork.projects.mentalHealth.description'),
      location: t('ourWork.projects.mentalHealth.location'),
      images: ['/unirmentes.svg', '/logodps.png'],
      highlights: t('ourWork.projects.mentalHealth.highlights', { returnObjects: true }) as string[]
    },
    {
      id: 'biotech',
      title: t('ourWork.projects.biotech.title'),
      description: t('ourWork.projects.biotech.description'),
      location: t('ourWork.projects.biotech.location'),
      images: ['/logoascella.png'],
      highlights: t('ourWork.projects.biotech.highlights', { returnObjects: true }) as string[]
    },
    {
      id: 'zonari',
      title: t('ourWork.projects.zonari.title'),
      description: t('ourWork.projects.zonari.description'),
      location: t('ourWork.projects.zonari.location'),
      images: ['/zonari-logo.svg'],
      highlights: t('ourWork.projects.zonari.highlights', { returnObjects: true }) as string[]
    },
    {
      id: 'tcgmadrid',
      title: t('ourWork.projects.tcgmadrid.title'),
      description: t('ourWork.projects.tcgmadrid.description'),
      location: t('ourWork.projects.tcgmadrid.location'),
      images: ['/logotcgmadrid.png'],
      highlights: t('ourWork.projects.tcgmadrid.highlights', { returnObjects: true }) as string[]
    },
    {
      id: 'apptivities',
      title: t('ourWork.projects.apptivities.title'),
      description: t('ourWork.projects.apptivities.description'),
      location: t('ourWork.projects.apptivities.location'),
      images: ['/apptivities_logo_h_dark.svg'],
      highlights: t('ourWork.projects.apptivities.highlights', { returnObjects: true }) as string[]
    }
  ];

  return (
    <div className={styles.colorWrapper}>
      <section id="OurWork" className={`${layoutStyles.container} ${styles.ourWork}`}>
        <div className={styles.header}>
          <h2>{t('ourWork.title')}</h2>
          <p className={styles.subtitle}>{t('ourWork.subtitle')}</p>
        </div>
        
        <div className={styles.projectsGrid}>
          {projects.map((project) => (
            <div key={project.id} className={styles.projectCard}>
              <div className={styles.projectImages}>
                {project.images.map((image, index) => (
                  <img 
                    key={index} 
                    src={image} 
                    alt={`${project.title} logo ${index + 1}`}
                    className={styles.projectLogo}
                  />
                ))}
              </div>
              
              <h3 className={styles.projectTitle}>{project.title}</h3>
              {project.location && (
                <span className={styles.locationBadge}>{project.location}</span>
              )}
              <p className={styles.projectDescription}>{project.description}</p>
              
              {project.highlights && project.highlights.length > 0 && (
                <ul className={styles.highlightsList}>
                  {project.highlights.map((highlight, index) => (
                    <li key={index}>{highlight}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default OurWork;

